import * as Yup from 'yup';

export const AddContactSchema = Yup.object().shape({
    name: Yup.string().trim().min(2, 'Name must be at least 2 characters').required('Customer name is required'),
    email: Yup.string().email('Please enter a valid email').required('Customer email is required'),
});

export type AddContactDataType = Yup.InferType<typeof AddContactSchema>;

type InitialValues = {
    name: string;
    email: string;
};

export const AddContactInitialValues: InitialValues = {
    name: '',
    email: '',
};

export interface AddContactInterface {
    name: string;
    email: string;
}
